<template>
  <!-- prettier-ignore -->
  <div
    class="section"
    :class="classes"
  >
    <div
      v-if="$slots.title"
    >
      <the-typography
        tag="h3"
        type="heading04"
        class="section__title"
      >
        <slot name="title" />
      </the-typography>
    </div>

    <div
      v-if="$slots.inactiveTitle"
    >
      <the-typography
        type="bodyLargeLong"
        tag="h3"
        class="section__title"
      >
        <slot name="inactiveTitle" />
      </the-typography>
    </div>

    <div
      v-if="$slots.content"
      class="section__content"
    >
      <slot name="content" />
    </div>

    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  isDap: {
    type: Boolean,
    default: false,
  },

  invalid: {
    type: Boolean,
    default: false,
  },

  theme: {
    type: String,
    default: 'light',
  },
})

const classes = computed(() => {
  return {
    [`section--${props.theme}`]: true,
    'section--invalid': props.invalid,
    'section--dap': props.isDap,
  }
})
</script>

<style name="mobile" scoped>
.section {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 16px;
  background-color: var(--c-primary-neutral-3);
  border: 1px solid transparent;
  transition: border-color 0.3s ease-in-out;
  color: var(--c-primary-neutral-1);
}

.section__title {
  margin: 0;
  transition: color 0.3s ease-in-out;
}

.section--invalid {
  border-color: var(--c-secondary-color-1);

  .section__title {
    color: var(--c-secondary-color-1);
  }
}

.section--dark {
  background-color: var(--c-primary-neutral-2);
}

.section--light {
  background-color: var(--c-primary-neutral-3);
}

.section__content {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .section {
    padding: 24px 16px;
  }
}
</style>

<style name="global">
/* Sections siblings should get a separator unscoped */
.section + .section {
  margin-top: 2px;
}
</style>
